<template>
  <div class="device-list">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>设备列表</span>
          <el-button type="primary" @click="refreshDevices">刷新</el-button>
        </div>
      </template>
      
      <el-table :data="devices" style="width: 100%">
        <el-table-column prop="device_id" label="设备ID" width="180"></el-table-column>
        <el-table-column prop="name" label="设备名称" width="180"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="last_seen" label="最后在线时间"></el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              size="small"
              @click="configureWifi(scope.row)"
              :disabled="scope.row.status === 'offline'">
              配置WiFi
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- WiFi配置对话框 -->
    <el-dialog
      v-model="dialogVisible"
      title="WiFi配置"
      width="30%">
      <el-form :model="wifiForm" label-width="80px">
        <el-form-item label="SSID">
          <el-input v-model="wifiForm.ssid"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="wifiForm.password" type="password"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveWifiConfig">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'

export default {
  name: 'DeviceList',
  setup() {
    const devices = ref([])
    const dialogVisible = ref(false)
    const wifiForm = ref({
      device_id: '',
      ssid: '',
      password: ''
    })

    const getDevices = async () => {
      try {
        const response = await axios.get('/api/devices.php')
        devices.value = response.data
      } catch (error) {
        ElMessage.error('获取设备列表失败')
      }
    }

    const refreshDevices = () => {
      getDevices()
    }

    const getStatusType = (status) => {
      const types = {
        online: 'success',
        offline: 'info',
        configuring: 'warning'
      }
      return types[status] || 'info'
    }

    const getStatusText = (status) => {
      const texts = {
        online: '在线',
        offline: '离线',
        configuring: '配置中'
      }
      return texts[status] || status
    }

    const configureWifi = (device) => {
      wifiForm.value.device_id = device.device_id
      dialogVisible.value = true
    }

    const saveWifiConfig = async () => {
      try {
        await axios.post('/api/wifi_config.php', wifiForm.value)
        ElMessage.success('WiFi配置已保存')
        dialogVisible.value = false
        refreshDevices()
      } catch (error) {
        ElMessage.error('保存WiFi配置失败')
      }
    }

    onMounted(() => {
      getDevices()
    })

    return {
      devices,
      dialogVisible,
      wifiForm,
      refreshDevices,
      getStatusType,
      getStatusText,
      configureWifi,
      saveWifiConfig
    }
  }
}
</script>

<style scoped>
.device-list {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style> 